import { ListingsSearchRouteParams } from '@kamernet/core/Routing/routes/ListingsSearch';

import { ListingsSearchAllFilters } from '@kamernet/modules/Search/types';

export function mapAllFiltersToRouteParams(
  allFilters: ListingsSearchAllFilters,
): ListingsSearchRouteParams {
  const routeParams: ListingsSearchRouteParams = {
    city: allFilters.citySlug,
    street: allFilters.streetSlug,
    searchCategories: allFilters.searchCategories,
    maxRent: allFilters.maxRent,
    minSize: allFilters.minSize,
    searchView: allFilters.searchView,
    furnishings: allFilters.furnishings,
    hasInternet: allFilters.hasInternet,
    isBathroomPrivate: allFilters.isBathroomPrivate,
    isKitchenPrivate: allFilters.isKitchenPrivate,
    isToiletPrivate: allFilters.isToiletPrivate,
    availabilityPeriods: allFilters.availabilityPeriods,
    availableFrom: allFilters.availableFrom,
    suitableForNumberOfPersons: allFilters.suitableForNumberOfPersons,
    suitableForGenders: allFilters.suitableForGenders,
    suitableForAge: allFilters.suitableForAge,
    suitableForWorkStatuses: allFilters.suitableForWorkStatuses,
    isSmokingInsideAllowed: allFilters.isSmokingInsideAllowed,
    isPetsInsideAllowed: allFilters.isPetsInsideAllowed,
    roommateNumberMax: allFilters.roommateNumberMax,
    roommateGenders: allFilters.roommateGenders,
    ownerTypes: allFilters.ownerTypes,
    radius: allFilters.radius,
    nwlat: allFilters.nwlat,
    nwlng: allFilters.nwlng,
    selat: allFilters.selat,
    selng: allFilters.selng,
    mapZoom: allFilters.mapZoom,
    sort: allFilters.sort,
    pageNo: allFilters.pageNo,
    mapMarkerLat: allFilters.mapMarkerLat,
    mapMarkerLng: allFilters.mapMarkerLng,
  };

  return routeParams;
}
